import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import { initDB } from "./utils/db";

// Import pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ForumDiskusi from "./pages/ForumDiskusi";
import AgriServis from "./pages/AgriServis";
import ProfileSaya from "./pages/ProfileSaya";
import UserManagement from "./pages/UserManagement";
import PengembanganDiri from "./pages/PengembanganDiri";
import BisnisSaya from "./pages/BisnisSaya";
import MyOrders from "./pages/MyOrders";
import LandingPage from "./pages/LandingPage";
import SurveyBuilder from "./pages/SurveyBuilder";
import SurveyList from "./pages/SurveyList";
import AdminAnalytics from "./pages/AdminAnalytics";
import LaporYuk from "./pages/LaporYuk";
import RawData from "./pages/RawData";
import AOPage from "./pages/AOPage";
import SyaratKetentuan from "./pages/SyaratKetentuan";
import KisahSukses from "./pages/KisahSukses";
import BeritaKakao from "./pages/BeritaKakao";
import CouponManagement from "./pages/CouponManagement";

// Import navbar
import PublicNavbar from "./components/navbar"; // Navbar sebelum login
import TopNavbar from "./components/TopNavbar"; // Navbar setelah login
import AnalyticsTracker from "./components/AnalyticsTracker";

function AppContent() {
  const { isLoggedIn, user, isAuthLoading } = useContext(AuthContext);

  // Wait for the stored session before choosing public or protected routes.
  if (isAuthLoading) {
    return null;
  }

  return (
    <>
      <AnalyticsTracker />
      {isLoggedIn ? <TopNavbar /> : <PublicNavbar />}
      <main className={`app-main ${isLoggedIn ? 'logged-in' : 'public'}`}>
        <Routes>
          <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />
          <Route path="/kisah-sukses" element={<KisahSukses />} />
          <Route path="/berita-kakao" element={<BeritaKakao />} />
          <Route path="/survey/:surveyId" element={<LaporYuk />} />

          {/* Halaman Sebelum Login */}
          {!isLoggedIn && <Route path="/" element={<LandingPage />} />}
          {!isLoggedIn && <Route path="/layanan" element={<Navigate to="/#tentang-sahabat-kakao" replace />} />}
          {!isLoggedIn && <Route path="/ao" element={<AOPage />} />}
          {!isLoggedIn && <Route path="/agriservis" element={<AgriServis />} />}
          {!isLoggedIn && <Route path="/pengembangandiri" element={<PengembanganDiri />} />}
          {!isLoggedIn && <Route path="/login" element={<Login />} />}

          {/* Redirect root "/" ke dashboard jika sudah login */}
          {isLoggedIn && <Route path="/" element={<Navigate to="/dashboard" />} />}

          {/* Halaman Setelah Login */}
          {isLoggedIn && <Route path="/dashboard" element={<Dashboard />} />}
          {isLoggedIn && <Route path="/pengembangandiri" element={<PengembanganDiri />} />}
          {isLoggedIn && <Route path="/bisnissaya" element={<BisnisSaya />} />}
          {isLoggedIn && <Route path="/myorders" element={<MyOrders />} />}
          {isLoggedIn && <Route path="/forum" element={<ForumDiskusi />} />}
          {isLoggedIn && <Route path="/laporyuk" element={<LaporYuk />} />}
          {isLoggedIn && <Route path="/profile" element={<ProfileSaya />} />}
          {isLoggedIn && <Route path="/user-management" element={<UserManagement />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/register" element={<Register />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/admin-analytics" element={<AdminAnalytics />} />}

          {/* Survey Builder */}
          {isLoggedIn && user?.role === 'admin' && <Route path="/survey-builder" element={<SurveyBuilder />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/survey-builder/:id" element={<SurveyBuilder />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/survey-list" element={<SurveyList />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/raw-data" element={<RawData />} />}
          {isLoggedIn && user?.role === 'admin' && <Route path="/coupons" element={<CouponManagement />} />}

          {/* Fallback jika route tidak dikenali */}
          <Route path="*" element={<Navigate to={isLoggedIn ? "/dashboard" : "/"} />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  useEffect(() => {
    initDB();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}
